export default __webpack_public_path__ + "static/src/assets/images/icons/placeorder_icon_quantity.png";